"use client";

import "@adyen/adyen-web/styles/adyen.css";
import "./Adyen.styles.css";

import { useEffect } from "react";

import { useCheckout } from "../../Checkout.hooks";
import { useAdyenCheckoutForm } from "./Adyen.hooks";
import AdyenErrorMessage from "./AdyenErrorMessage";
import AdyenWidget from "./AdyenWidget";
import AdyenLoadingSkeleton from "./AdyenWidgetLoadingSkeleton";
import { checkoutStore } from "../../Checkout.store";

export default function Adyen() {
  const { data: checkout } = useCheckout();
  const counter = checkoutStore((state) => state.counter);
  const { data, error, refetch, isPending, isError } = useAdyenCheckoutForm();

  useEffect(() => {
    if (!checkout?.totalGrossAmount) return;
    refetch();
  }, [refetch, checkout?.totalGrossAmount, counter]);

  if (isError) {
    return <AdyenErrorMessage message={error.message} />;
  }

  if (isPending) {
    return <AdyenLoadingSkeleton />;
  }

  return <AdyenWidget adyenCheckoutForm={data} cartId={checkout?.id ?? 0} />;
}
